import { Injectable } from '@angular/core';
import { CHttp } from '../../core/services/chttp.service';
import { config } from '../../app.config';
import { OfferDetails } from '../interfaces/offer.interfaces';

@Injectable()
export class OffersService {
  constructor(private http: CHttp) { }

  public getOffers(data?: any) {
    return this.http.get(config.api_url + 'offers', {
      params: data,
    });
  }

  public getOffer(id: string) {
    return this.http.get(config.api_url + 'offers/' + id);
  }

  public addOffer(data: OfferDetails) {
    this.clearContacts(data);
    this.filterEmptyTermsAndConditions(data);
    return this.http.post(config.api_url + 'offers', data);
  }

  public updateOffer(data: OfferDetails, id: string) {
    this.clearContacts(data);
    this.filterEmptyTermsAndConditions(data);
    return this.http.put(config.api_url + `offers/${id}`, data);
  }

  public getOfferRedemptions() {
    return this.http.get(config.api_url + 'offers');
  }

  public deleteOffer(id: string) {
    return this.http.delete(config.api_url + 'offers/' + id);
  }

  private clearContacts(offer: OfferDetails) {
    if (offer.establishment.contactNames === []) {
      offer.establishment.contactNames = null;
    }
    if (offer.establishment.contactEmails === []) {
      offer.establishment.contactEmails = null;
    }
    if (offer.establishment.contactPhones === []) {
      offer.establishment.contactPhones = null;
    }
  }

  public updateOfferIsNew(id: string, isNew: boolean) {
    return this.http.put(config.api_url + `offers/${id}/is-new`, { isNew });
  }

  private filterEmptyTermsAndConditions(offer: OfferDetails) {
    if (offer.offerAvailabilitySlots) {
      offer.offerAvailabilitySlots.forEach(slot => {
        if (slot.termsAndConditions) {
          slot.termsAndConditions = slot.termsAndConditions
            .filter(term => term != null && typeof term === 'string')
            .map(term => term.trim());

          if (slot.termsAndConditions.length === 0) {
            slot.termsAndConditions = [];
          }
        }
      });
    }
  }
}



// WEBPACK FOOTER //
// /Users/thxgg/Projects/Work/code-hospitality-cms/src/app/offers/services/offers.service.ts